var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_4133)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7607 81.3213H27.3829V79.6324H30.7607V81.3213Z",
    fill: "#D4D8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4727 81.3213H37.0948V79.6324H40.4727V81.3213Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5625 87.2314H32.8736V83.8536H34.5625V87.2314Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5615 77.5205H32.8726V74.1427H34.5615V77.5205Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5389 32.173C53.0111 32.173 60.8892 26.1309 66.4171 26.1309C71.945 26.1309 83.5549 29.3619 83.5549 55.2184C83.5549 81.075 67.9363 84.8692 61.8561 84.8692C33.3838 84.8709 21.2217 32.173 41.5389 32.173Z",
    fill: "url(#paint0_linear_390_4133)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5971 37.8328C78.008 37.8328 76.7148 36.5179 76.7148 34.9022C76.7148 33.2865 78.008 31.9717 79.5971 31.9717C81.1862 31.9717 82.4793 33.2865 82.4793 34.9022C82.4793 36.5179 81.1862 37.8328 79.5971 37.8328ZM79.5971 33.9254C79.0687 33.9254 78.6363 34.363 78.6363 34.9022C78.6363 35.4414 79.0687 35.8791 79.5971 35.8791C80.1255 35.8791 80.5578 35.4414 80.5578 34.9022C80.5578 34.363 80.1255 33.9254 79.5971 33.9254Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3878 67.9122C59.8071 67.9122 61.7682 65.9505 61.7682 63.5306C61.7682 61.1107 59.8071 59.149 57.3878 59.149C54.9686 59.149 53.0074 61.1107 53.0074 63.5306C53.0074 65.9505 54.9686 67.9122 57.3878 67.9122ZM57.3878 71.2145C61.6304 71.2145 65.0696 67.7743 65.0696 63.5306C65.0696 59.2869 61.6304 55.8467 57.3878 55.8467C53.1453 55.8467 49.7061 59.2869 49.7061 63.5306C49.7061 67.7743 53.1453 71.2145 57.3878 71.2145Z",
    fill: "#433ED1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1405 71.754L57.6217 66.7683L59.8345 64.3176L65.3533 69.3032L63.1405 71.754Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5432 78.9231H44.3455C41.8453 78.9231 39.8125 76.9135 39.8125 74.4417V53.5283C39.8125 51.0566 41.8453 49.0469 44.3455 49.0469H71.5432C74.0433 49.0469 76.0761 51.0566 76.0761 53.5283V74.4417C76.0761 76.9135 74.0433 78.9231 71.5432 78.9231ZM44.3455 52.0345C43.5114 52.0345 42.8345 52.7037 42.8345 53.5283V74.4417C42.8345 75.2663 43.5114 75.9355 44.3455 75.9355H71.5432C72.3772 75.9355 73.0541 75.2663 73.0541 74.4417V53.5283C73.0541 52.7037 72.3772 52.0345 71.5432 52.0345H44.3455Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0332 43.0706H67.0112C67.0112 38.1291 62.9436 34.1077 57.9453 34.1077C52.947 34.1077 48.8794 38.1291 48.8794 43.0706V50.5397H45.8574V43.0706C45.8574 36.4799 51.2788 31.1201 57.9453 31.1201C64.6117 31.1201 70.0332 36.4799 70.0332 43.0706Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_4133",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_4133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_4133",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_4133",
    x1: 57.4991,
    y1: 26.1309,
    x2: 57.4991,
    y2: 84.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1FE",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk15);
export default __webpack_public_path__ + "static/media/uwalk15.02a8f53db67d07dc8040d23a86f65a04.svg";
export { ForwardRef as ReactComponent };